export default class formConfig {
  // 区管单位
  static configList() {
    return [
      {
        title: "项目基本信息",
        name: "1",
        icon: "",
        formConfigList: [
          {
            label: "项目名称：",
            value: "prjName",
            type: "input",
            width: "100%",
            disabled: true,
          },
          {
            label: "报建编号：",
            type: "input",
            value: "constructionNo",
            disabled: true,
          },
          {
            label: "备案项目类别：",
            type: "input",
            value: "tenderClassNumName",
            disabled: true,
          },
          {
            label: "备案项目内容：",
            type: "input",
            value: "tenderContent",
            disabled: true,
          },
          {
            label: "招标监管部门：",
            type: "input",
            value: "regulatorsName",
            disabled: true,
          },
          {
            label: "项目负责人（总监）：",
            type: "input",
            value: "personName",
            disabled: true,
          },
          {
            label: "身份证号：",
            type: "input",
            value: "idCard",
            disabled: true,
          },
        ]
      },
      {
        title: "变更后项目负责人（总监）",
        name: "2",
        icon: "",
        formConfigList: [
          {
            label: "施工单位名称：",
            value: "corpName",
            type: "input",
            disabled: true
          },{
            label: "变更后项目负责人（总监）：",
            value: "basicinfoChangeName",
            type: "input",
            disabled: true
          },
          {
            label: "变更后身份证号：",
            value: "chageIdCard",
            type: "input",
            disabled: true
          },
        ]
      },
      {
        title: "项目负责人/总监变更申请扫描件",
        name: "3",
        icon: "",
        formConfigList: [
          {
            label: "变更申请扫描件：",
            type: "slot",
            slotName: "uploadFile",
            width: "100%",
          },
        ]
      },
      {
        title: "核验",
        name: "4",
        icon: "",
        formConfigList: [
          {
            label: "核验意见：",
            value: "auditOpinion",
            type: "textarea",
            width: "100%;",
            maxlength: 500,
            disabled: false,
            rule: [
              {
                required: true,
                message: "该输入项不能为空",
                trigger: "blur"
              }
            ]
          }
        ]
      },
    ];
  }
}
